import React from 'react'
import idGenerator from 'react-id-generator'

// Lets import icons
import euFlag from '../img/eu.png'

// Lets import styles for component
import './Footer.sass'

const Footer = ({socialNetworks, t}) => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footerActions">
          <div className="left">
            <div className="title">
              {t('footer_eu_neighbours')}
            </div>
            <div className="description">
              {t('footer_description')}
            </div>
            <div className="actionButton">
              <a 
                href="https://www.euneighbours.eu/en/policy/about-project"
                aria-label={t('footer_read_more')}
              >
                {t('footer_read_more')}
              </a>
            </div>
          </div>
          <div className="right">
            <div className="flexWrap">
              <div className="actionItem">
                <a 
                  href="https://www.euneighbours.eu/en/south/eu-in-action"
                  aria-label={t('footer_eu_neighbours')}
                >
                  <div className="text left">
                    <strong>{t('footer_eu_neighbours')}</strong>
                    <div className="orange">
                      {t('footer_south')}
                    </div>
                  </div>
                </a>
              </div>
              <div className="actionItem">
                <a 
                  href="https://www.euneighbours.eu/en/east/eu-in-action"
                  aria-label={t('footer_eu_neighbours')}
                >
                  <div className="text right">
                    <strong>{t('footer_eu_neighbours')}</strong>
                    <div className="green">
                      {t('footer_east')}
                    </div>
                  </div>
                </a>
              </div>
              <div className="actionItem small">
                <a 
                  href="https://openmediahub.com/ru/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label={t('footer_supporting_media')}
                >
                  <div className="text">
                    <div>
                      <strong>{t('footer_open')}</strong>
                      <span className="regular">{t('footer_media_hub')}</span>
                    </div>
                    <small>{t('footer_supporting_media')}</small>
                  </div>
                </a>
              </div>
              <div className="actionItem big m0">
                <a 
                  href="https://www.euneighbours.eu/en/user/register"
                  aria-label={t('footer_subscribe')}
                >
                  <div className="text">
                    <strong>{t('footer_subscribe')}</strong>
                  </div>
                </a>
              </div>
              <div className="actionItem small m0">
                <a 
                  href="https://www.eu-neighbours.news/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label={t('footer_news')}
                >
                  <div className="text">
                    <div>
                      <strong>{t('footer_eu_neighbours')}</strong>
                      <span className="regular">{t('footer_news')}</span>
                    </div>
                    <small>{t('footer_ue_corporation')}</small>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bottomFooter">
        <div className="container">
          <div className="copyright">
            <div className="foundedBy">
              <div className="text">
                {t('footer_project_founded')}
              </div> 
              <div className="icon">
                <img src={euFlag} alt="flag"/>
              </div>
            </div>
            <div className="socialNetworks">
              <ul>
                {socialNetworks.map((network, i) => {
                  return (
                    i <= 2 ? (
                      <li key={idGenerator()}>
                        <a 
                          href={network.url}
                          aria-label="icon"
                        >
                          <img src={network.icon.publicURL} alt="socilaNetwork icon"/>
                        </a>
                      </li>
                    ) : null
                  )
                })}
              </ul>
            </div>
            <div className="copy">
              {t('footer_copyright')}
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
